import React from "react";
import FieldPopover from "../popover/popover";
import FieldConfig from "../../proto/field-config";
import {GROUP_INFO} from "../../../gd/const/fields/field2-groups";
import FieldFormula_Popover from "./components/popover-menu/popover";
import FieldFormula_InlineValueEmpty from "./components/inline-edit/value-empty";
import FieldFormula_InlineValueNotEmpty from "./components/inline-edit/value-not-empty";
import Formula from "../../../gd/utils/formula";
import FieldFormula_View from "./render/view";
import FieldFormula_InlineEdit from "./render/inline-edit";
import FieldFormula_Editable from "./render/editable/editable";
import FieldFormula_TableCell from "./render/table/table-cell";
import {FieldFilterType} from "../../proto/types";
import FieldFormula_ViewProperty from "./render/property"

export default class FieldFormula extends FieldPopover {

    public formula          : string    // formula itself i.e. value
    public formatType       : string    // how we format string or number

    constructor(config:FieldConfig) {
        super(config);

        this.typeLabel          = "Formula";
        this.typeGroup          = GROUP_INFO
        this.typeDescription    = "Formula field"

        this.filterType         = FieldFilterType.NUMBER;
        this.icon               = 'i5-formula';

        this.placeholder        = 'Invalid value';

        //special
        this.formula            = _.get(config, 'formula', '');
        this.symbolId           = _.get(config, 'symbolId', 'us_dollar');
        this.decimalPlaces      = _.get(config, 'decimalPlaces', 0);
        this.formatType         = _.get(config, 'formatType', 'default');

        this.isSearchable       = true;

        this.components.PopoverMenu         = FieldFormula_Popover
        this.components.InlineValueEmpty    = FieldFormula_InlineValueEmpty
        this.components.InlineValueNotEmpty = FieldFormula_InlineValueNotEmpty

        this.components.ValuePrefix         = this.formatType === 'currency' ? <span className="ui5-txt-not-important m-r-5 fl-no-shrink">{gd.const.currency[this.symbolId].symbol}</span> : null


        this.renderComponents.view              = FieldFormula_View
        this.renderComponents.viewSmall         = FieldFormula_View
        this.renderComponents.inlineEditable    = FieldFormula_InlineEdit

        this.renderComponents.editable          = FieldFormula_Editable
        this.renderComponents.tableCell         = FieldFormula_TableCell
        this.renderComponents.viewProperty      = FieldFormula_ViewProperty
    }

    access(model:any) : 'read' | 'write' | false {
        return 'read';
    }


    // DEPRICATED
    // WARNING!!!: Formula util refers to gd.const.fields.labels and gd.session.customFields names while processing fields in formula
    _getValue(model:any) {
        return Formula.process(this.formula, model).result
    }

    // USE this instead of _getValue
    // WARNING!!!: Formula util refers to gd.const.fields.labels and gd.session.customFields names while processing fields in formula
    calculateValue(model:any) {
        return Formula.process(this.formula, model).result
    }

    sortValue(value:any, model:any) { return this.calculateValue(model) }

    searchValue(value:any, model:any) { return this.calculateValue(model) || '' }

    /*** VALIDATION FUNCTIONS ***/

    isValueValid(value:any) {return _.isNil(value) || !isNaN(value) || value.length === 0}

    /*** DISPLAY VALUE FUNCTIONS [INPUT ONLY] ***/

    getDisplayValue(value:any) {

        if (isNaN(value)) return value;

        let res = value;

        switch (this.formatType) {
            case 'currency':
                if (this.isValueValid(value)) {
                    switch (typeof value) {
                        case 'number':  res = value; break;
                        default:        res = parseFloat(value); break;
                    }
                }

                res = isNaN(res) ? null : res.toLocaleString('en', { useGrouping:true, minimumFractionDigits: this.decimalPlaces, maximumFractionDigits: this.decimalPlaces });
                break;

            case 'percentage':
                if (this.isValueValid(value)) {
                    switch (typeof value) {
                        case 'number':  res = value.toFixed(this.decimalPlaces); break;
                        default:        res = parseFloat(value).toFixed(this.decimalPlaces); break;
                    }
                }

                res = isNaN(res) ? null : res + ' %';
                break

            case 'number':
            default:
                if (this.isValueValid(value)) {
                    switch (typeof value) {
                        case 'number':  res = value.toFixed(this.decimalPlaces); break;
                        default:        res = parseFloat(value).toFixed(this.decimalPlaces); break;
                    }
                }

                res = isNaN(res) ? null : res;
                break;
        }

        return res;
    }

    getFormulaWithValues(model:any) {
        return Formula.process(this.formula, model).formulaWithValues;
    }


    /*** IMPORT EXPORT ***/

    normalizeToCSVValue(model: any): any {
        return Formula.process(this.formula, model).result
    }

    toJson() {
        let result = super.toJson();
        result.formula = this.formula;
        return result;
    }
}
